import "./Banglore_cities.css";
const Mumbai_cities = ()=>{
    return(
        <div className="main_div">
            <h2 className="city">Popular Localities</h2>
            <p className="city">Andheri East</p>
            <p className="city">Vashi</p>
            <p className="city">Andheri West</p>
            <p className="city">Thane</p>
            <p className="city">Bandra</p>
            <p className="city">Dadar</p>
            <p className="city">Panvel</p>
            <p className="city">Navi Mumbai</p>
            <p className="city">All of Mumbai</p>
           
        </div>
    )
}
export {Mumbai_cities}